<script setup lang="ts">
import { formatTimeAgo } from '@vueuse/core'

const { isNotificationsSlideoverOpen } = useDashboard()
const notif = useNotification()
</script>

<template>
  <USlideover v-model:open="isNotificationsSlideoverOpen" title="Notifications">
    <template #body>
      <div
        v-if="notif.itemsWithMeta.value.length === 0"
        class="flex flex-col items-center justify-center py-12 text-center"
      >
        <UIcon name="i-lucide-bell-off" class="size-12 text-muted mb-4" />
        <h3 class="text-highlighted font-medium mb-2">Aucune notification</h3>
        <p class="text-dimmed text-sm">
          Vous êtes à jour ! Les nouvelles notifications de réservation
          apparaîtront ici.
        </p>
      </div>

      <NuxtLink
        v-for="notification in notif.itemsWithMeta.value"
        :key="notification.id"
        :to="`app/bookings/${notification.bookingId}`"
        class="px-3 py-2.5 rounded-md hover:bg-elevated/50 flex items-center gap-3 relative -mx-3 first:-mt-3 last:-mb-3"
        @click="notif.markAsRead(String(notification.rawId))"
      >
        <UChip color="error" :show="!!notification.unread" inset>
          <UAvatar
            v-bind="notification.sender.avatar"
            :alt="notification.sender.name"
            size="md"
          />
        </UChip>

        <div class="text-sm flex-1">
          <p class="flex items-center justify-between">
            <span class="text-highlighted font-medium">{{
              notification.title
            }}</span>

            <time
              :datetime="notification.date"
              class="text-muted text-xs"
              v-text="formatTimeAgo(new Date(notification.date))"
            />
          </p>

          <p class="text-dimmed">
            {{ notification.body }}
          </p>
        </div>
      </NuxtLink>
    </template>
  </USlideover>
</template>
